import React, { Component, Fragment } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import NewProyectoForm from "./NewProyectoForm";
import { IconPencil } from "../ui/icons";

class NewProyectoModal extends Component {
  state = {
    modal: false
  };

  toggle = () => {
    this.setState(previous => ({
      modal: !previous.modal
    }));
  };

  render() {
    const create = this.props.create;

    var title = "Editando Proyecto";
    // "Editar" is a utility action, not the primary brand action — keep it
    // neutral so it doesn't compete visually with the destructive Remover
    // button that sits next to it in table rows.
    var button = (
      <Button
        color="secondary"
        onClick={this.toggle}
        size="sm"
        data-lssi-action-icon
        aria-label="Editar Proyecto"
        title="Editar Proyecto"
      >
        <IconPencil />
        <span className="lssi-action-label"> Editar Proyecto</span>
      </Button>
    );
    if (create) {
      title = "Creando Nuevo Proyecto";

      button = (
        <Button
          color="primary"
          className="float-end"
          onClick={this.toggle}
          style={{ minWidth: "200px" }}
          size="sm" block
        >
          Crear Nuevo Proyecto
        </Button>
      );
    }

    return (
      <Fragment>
        {button}
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>{title}</ModalHeader>

          <ModalBody>
            <NewProyectoForm
              resetState={this.props.resetState}
              toggle={this.toggle}
              proyecto={this.props.proyecto}
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default NewProyectoModal;